export default __webpack_public_path__ + "static/media/edit.a1a59f76.svg";